import React, { useContext, useState } from "react"
import { motion } from "framer-motion"
import { useTranslation } from "react-i18next"
import { isMobileContext } from "../context/isMobileContext"
import DownloadBtn from "../common/DownloadBtn"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/free-mode"
import "swiper/css/pagination"
import { Navigation, Pagination } from "swiper"
import FsLightbox from "fslightbox-react"

const Goals = () => {
	const { isMobile } = useContext(isMobileContext)
	const { t,i18n } = useTranslation()
	const [toggler, setToggler] = useState(false)
	const [toggler2, setToggler2] = useState(false)

	const goals = [
		{
			img: t('Goals.imgs.img1'),
		},
		{
			img: t('Goals.imgs.img2'),
		},
		{
			img: t('Goals.imgs.img3'),
		},
		{
			img: t('Goals.imgs.img4'),
		},
		{
			img: t('Goals.imgs.img5'),
		},
		{
			img: t('Goals.imgs.img6'),
		},
		{
			img: t('Goals.imgs.img7'),
		},
	]

	return (
		<div className="goals">
			<div className="goals-header">
				<div className="header-container">
					<div className="header">
						<div className="title-container">
							<motion.h2
								initial={{ opacity: 0, translateY: "100%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{
									ease: "easeInOut",
									delay: isMobile ? 0.2 : 0.2,
									duration: 0.5,
								}}
								className="title1"
							>
								{t("Goals.headLine1")}
							</motion.h2>
						</div>
						<div className="title-container">
							<motion.h2
								initial={{ opacity: 0, translateY: "100%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{
									ease: "easeInOut",
									delay: isMobile ? 0.7 : 0.2,
									duration: 0.5,
								}}
								className="title2"
							>
								{t("Goals.headLine2-1")}
							</motion.h2>
						</div>
					</div>
				</div>
				<motion.p
					initial={{ opacity: 0 }}
					whileInView={{ opacity: 1 }}
					viewport={{ once: true }}
					transition={{
						ease: "easeInOut",
						delay: isMobile ? 0.75 : 0.5,
						duration: 0.5,
					}}
				>
					{t("Goals.description")}
				</motion.p>
			</div>

			<div className="goals-wrapper">
				{!isMobile && (
					<div className="goals-content">
						{goals.map((item, i) => (
							<div className="img-wrapper" key={i}>
								<img src={process.env.PUBLIC_URL + item.img} alt="img" />
							</div>
						))}
					</div>
				)}
				{isMobile && (
					<div className="goals-content">
						<Swiper
							key={Math.random(0, 100)}
							style={{ direction: i18n.language === "ar" ? "rtl" : "ltr" }}
							breakpoints={{
								0: {
									slidesPerView: 1,
									spaceBetween: 0,
								},
							}}
							modules={[Navigation]}
							navigation={{
								nextEl: `.goals-next`,
								prevEl: `.goals-prev`,
							}}
							className="goals-swiper"
						>
							{goals.map((item, index) => (
								<SwiperSlide key={index}>
									<motion.div
										initial={{ opacity: 0 }}
										whileInView={{ opacity: 1 }}
										viewport={{ once: true }}
										transition={{
											ease: "easeInOut",
											delay: isMobile
												? 0.3 + parseFloat(index * 0.055)
												: 0.75 + parseFloat(index / 10),
											duration: 0.5,
										}}
										className="img-wrapper"
									>
										<img src={process.env.PUBLIC_URL + item.img} alt="img" />
									</motion.div>
								</SwiperSlide>
							))}
						</Swiper>
						{isMobile && (
							<motion.div
								initial={{ opacity: 0 }}
								whileInView={{ opacity: 1 }}
								viewport={{ once: true }}
								transition={{
									ease: "easeInOut",
									delay: isMobile ? 0.6 : 1,
									duration: 0.5,
								}}
								className="goals-navigation-container"
							>
								<div className={`swiper-button-prev goals-prev`}></div>
								<div className={`swiper-button-next goals-next`}></div>
							</motion.div>
						)}
					</div>
				)}
				{/* <motion.div
					initial={{ opacity: 0 }}
					whileInView={{ opacity: 1 }}
					viewport={{ once: true }}
					transition={{
						ease: "easeInOut",
						delay: isMobile ? 0.8 : 1.25,
						duration: 0.5,
					}}
					className="buttons"
				>
					<button
					className="downloadBtn gold strategy"
					gold
					onClick={() => setToggler(!toggler)}
				>
					{t("buttons.button1")}
				</button>
				<button
					className="downloadBtn gold strategy outlined"
					gold
					onClick={() => setToggler2(!toggler2)}
				>
					{t("buttons.button2")}
				</button>
				</motion.div> */}
				{/* {i18n.language === "en" ?
					<FsLightbox
						toggler={toggler}
						sources={[process.env.PUBLIC_URL + "/imgs/home-page/Ajman-Municipality-Sustainability-Report-2022-1-5-pat-1.png"]}
					/>
					:
					<FsLightbox
						toggler={toggler}
						sources={[process.env.PUBLIC_URL + "/imgs/home-page/Ajman-Municipality-Sustainability-Report-2022-1-5-pat-1A.png"]}
					/>
				}
				{i18n.language === "en" ?
					<FsLightbox
					toggler={toggler2}
					sources={[process.env.PUBLIC_URL + "/imgs/home-page/Ajman-Municipality-Sustainability-Report-2022-1-5-pat-2.png" ]}
				/>
				:
				<FsLightbox
					toggler={toggler2}
					sources={[process.env.PUBLIC_URL + "/imgs/home-page/Ajman-Municipality-Sustainability-Report-2022-1-5-pat-2A.png"]}
				/> */}
			{/* } */}
			</div>
			{isMobile && (
				<div className="back-layer1-mobile">
					<img
						src={process.env.PUBLIC_URL + "/imgs/home-page/vector-bg.png"}
						alt="back-layer"
					/>
				</div>
			)}
			{isMobile && (
				<div className="back-layer2-mobile">
					<img
						src={process.env.PUBLIC_URL + "/imgs/home-page/Subtract.png"}
						alt="back-layer"
					/>
				</div>
			)}
		</div>
	)
}

export default Goals
